// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__1PggW","meals-appear":"AvailableMeals_meals-appear__1hJEd"};